module.exports = __webpack_public_path__ + "img/9788990522870.d6312c89.jpg";